import { gql } from '@apollo/client';
import type { SortTopic_TopicFragment } from '../../graphql/generated/graphqlTypes';

const TOPIC_FRAGMENT = gql`
  fragment sortTopic_topic on Topic {
    order
    name
    score
  }
`;

export default function sortTopic(
  a: SortTopic_TopicFragment,
  b: SortTopic_TopicFragment,
) {
  if (a.order != null || b.order != null) {
    if (a.order != null && b.order != null) {
      return a.order - b.order;
    }
    return a.order != null ? -1 : 1;
  }
  if (a.name === b.name) {
    return (b.score || 0) - (a.score || 0);
  }

  return a.name < b.name ? -1 : 1;
}

sortTopic.fragments = {
  topic: TOPIC_FRAGMENT,
};
